// extracted by mini-css-extract-plugin
export default {"container":"Video_container__l34vj","textOverlay":"Video_textOverlay__7uQ75"};